export enum Align {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
}
